import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    fid: 1,
    agent: '',
    token: '',
    userInfo: {},
    addressInfo: {},
    tickets: [],
    userTickets: {},
    prevActive: '',
    needRefresh: false
  },
  mutations: {
    getFid (state) {
      return state.fid
    },
    setFid (state, newValue) {
      state.fid = newValue
    },
    getAll (state) {
      return {agent: state.agent,token: state.token, userInfo: state.userInfo, tickets: state.tickets, userTickets: state.userTickets}
    },
    setAgent (state, newValue) {
      state.agent = newValue
    },
    setTickets (state, tickets) {
      state.tickets = tickets
    },
    setAddressInfo (state, addressInfo) {
      state.addressInfo = addressInfo
    },
    setUserTickets (state, userTickets) {
      state.userTickets = userTickets
    },
    setPrevActive (state, prevActive) {
      state.prevActive = prevActive
    },
    setAll (state, payload) {
      state.agent = payload.agent
      state.token = payload.token
      state.userInfo = payload.userInfo
    },
    clearAgent (state) {
      state.agent = ''
    },
    clearToken (state) {
      state.token = ''
    },
    clearUserInfo (state) {
      state.userInfo = {}
    },
    clearAll (state) {
      state.agent = ''
      state.token = ''
      state.addressInfo = {}
      state.tickets = []
      state.userTickets = {}
      state.prevActive = ''
    },
    setNeedRefresh (state, status) {
      state.needRefresh = status
    },
  },
  actions: {
  },
  modules: {
  }
})
